var _style, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1024px",
    height: "1024px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:none;stroke:#FFFFFF;stroke-width:36;stroke-miterlimit:10;}\n\t.st2{fill:#0B76B7;}\n\t.st3{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_3",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M787,443H527.2L397.3,668l129.9,225H787l129.9-225L787,443z M657,795c-70.7,0-128-57.3-128-128 s57.3-128,128-128s128,57.3,128,128S727.7,795,657,795z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M903.9,246.2l-43-24.9c-2.2-0.8-4.4-1.8-6.3-3L545.9,40.1c-18.6-10.8-49.4-10.8-68.1,0L120.1,246.6 C101.4,257.3,86,283.9,86,305.5v50.7l0.1,362.3c-0.1,11.6,4.4,24.8,11.5,36c0.2,0.5,0.6,1.1,1,1.6c0.4,0.6,0.7,1.2,1.2,1.8 c5.7,8.1,12.7,15.1,20.3,19.6l357.6,206.4c18.8,10.9,49.4,10.9,68.1,0l357.6-206.4c18.8-10.9,34.1-37.4,34.1-59V362.1 c0-2.1,0.1-4,0.4-6v-50.8C938,283.7,922.6,257.1,903.9,246.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M643.6,270.5H541v-44.7H213.6V339H321v198.6h41.7v128.6c0,8,6.5,14.5,14.5,14.5h95.2v-29h-80.7V537.5h42.3V339 H541v-39.4h88.1v172.4h29V285C658.2,277,651.7,270.5,643.6,270.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M644.9,584.9c-43.2,0-78.4,35.2-78.4,78.4s35.2,78.4,78.4,78.4s78.4-35.2,78.4-78.4S688.1,584.9,644.9,584.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M657.8,471.7v85c36,4.3,66.5,26.5,82.5,57.4h77v-50.3L657.8,471.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M538,652c5.2-48.8,43.2-88,91.4-94.9v-83.9l-157,90.7V652H538z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M737.3,718.1c-18.7,31.5-53.1,52.7-92.4,52.7c-53.5,0-98-39.3-106.1-90.5h-66.3v82.6l172.4,99.5l172.4-99.5 v-44.8H737.3z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "350,508.5 350,309.9 242.6,309.9 242.6,254.8 511.9,254.8 511.9,309.9 405.1,309.9 405.1,508.5  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.38362038fa8f127a04e2086e8295665b.svg";
export { ForwardRef as ReactComponent };